import React, { forwardRef } from 'react';
import { Text, TextProps } from '../Text';

/**
 * @deprecated use `HeadingText` from `genesis-core` instead
 */

export const HeadingThree = forwardRef<HTMLElement, TextProps>((props, ref) => (
  <Text
    as="h3"
    color="onSurface.text.primary"
    typography="headingThree"
    ref={ref}
    {...props}
  />
));

HeadingThree.displayName = 'HeadingThree';
